import { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    CardActions,
    Grid,
    FormControl,
    FormControlLabel,
    Radio,
    TextField,
    Box, Divider, RadioGroup,
} from "@mui/material";
import { useData } from "../../../context/DataContext";
import { createSoilReport, updateSoilReport } from "../../../context/createAPI"
import SoilVillageCreation from "../SoilVillageCreation/SoilVillageCreation";
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../components/buttons/customButton';
import SingleSelect from '../../../components/Selections/singleSelect';
import SnackbarMessage from '../../../components/snackBar/snackBar';



function SoilReportCreation() {
    const navigate = useNavigate();

    const { years = [], soilTypes = [], cropTypes = [], soilReports = [], villageGroups = [], farmers = [], user = {}, handleSoilReports } = useData();
    const yearIndex = years[0]?.value;
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const types = [
        { value: "1", label: "Farmer" },
        ...user.level_id === 2 ? [] : [{ value: "2", label: "Village" }],
    ];

    const [state, setState] = useState({
        selectedVillageValue: "",
        selectedGroupValue: "",
        selectedFarmerValue: "",
        selectedSoilTypeId: "",
        selectedCorpsTypeId: "",
        selectedFarmerOrVillageType: "1",
        surveyNumber: "",
        phValue: "",
        ecValue: "",
        ocValue: "",
        nValue: "",
        kValue: "",
        pValue: "",
        clayContent: "",
        cecValue: "",
        target_year: yearIndex,
        farmersEnable: true,
        loading: false,
        submitMessage: "",
        selectedLevelOption: 1,
        groupsArray: [],
        villagesArray: [],
        farmersArray: []
    });

    const [errors, setErrors] = useState({});

    const handleFarmers = (name, value) => {
        let remainingFarmersData = [];

        if (user.level_id === 1 && name === "selectedVillageValue") {
            const data = soilReports.filter((item) => item.report_level_id === 1);
            const soilFarmerData = data.filter((item) => item.village_id !== null && item.farmer_id !== null && item.year_id === yearIndex)
            const farmersData = farmers.filter((item) => parseInt(item.village_id) === parseInt(value)).map((a) => ({ value: a.id, label: `${a.farmer_name} (${a.relative_name})` }))
            const farmerIds = soilFarmerData.map(item => item.farmer_id);
            // remainingFarmersData = farmersData.filter(farmer => !farmerIds.includes(farmer.value));
            remainingFarmersData = farmersData;

        } else if (user.level_id === 2 && name === "selectedGroupValue") {
            const data = soilReports.filter((item) => item.report_level_id === 2 && item.year_id === yearIndex)
            const farmersData = farmers.filter((item) => parseInt(item.ff_group_id) === parseInt(value)).map((a) => ({ value: a.id, label: `${a.farmer_name} (${a.relative_name})` }))
            const farmerIds = data.map(item => item.farmer_id);
            // remainingFarmersData = farmersData.filter(farmer => !farmerIds.includes(farmer.value));
            remainingFarmersData = farmersData;
        }


        setState((prev) => ({
            ...prev,
            farmersArray: remainingFarmersData,
            farmersEnable: false
        }));
    }

    const handleInputChange = (name, value) => {

        if (name === "selectedVillageValue" || name === "selectedGroupValue") {
            handleFarmers(name, value)
        }

        const regex = /^\d{0,5}(\.\d{0,2})?$/;
        const decimalFields1 = ["surveyNumber"];
        const regex1 = /^[a-zA-Z0-9\/\\-]+$/;

        const decimalFields = [
            "phValue",
            "ecValue",
            "ocValue",
            "nValue",
            "pValue",
            "kValue",
            "clayContent",
            "cecValue"
        ];
        if (decimalFields.includes(name)) {
            if (regex.test(value) || value === "") {
                setState((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        } else if (decimalFields1.includes(name)) {
            if (regex1.test(value) || value === "") {
                setState((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        }
        else {
            setState((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        if (name === "selectedFarmerValue") {
            const existingFarmerSoilDetails = soilReports.find(
                item => Number(item.farmer_id) === Number(value)
            );

            if (existingFarmerSoilDetails) {
                const { soil_type_id, crop_type_id, survey_no, ph, ec, oc, n, k, p, clay_content, cec } = existingFarmerSoilDetails;
                setState((prev) => ({
                    ...prev,
                    selectedSoilTypeId: soil_type_id ?? "",
                    selectedCorpsTypeId: crop_type_id ?? "",
                    surveyNumber: survey_no ?? "",
                    phValue: ph ?? "",
                    ecValue: ec ?? "",
                    ocValue: oc ?? "",
                    nValue: n ?? "",
                    kValue: k ?? "",
                    pValue: p ?? "",
                    clayContent: clay_content ?? "",
                    cecValue: cec ?? ""
                }))
            } else {
                setState((prev) => ({
                    ...prev,
                    selectedSoilTypeId: "",
                    selectedCorpsTypeId: "",
                    surveyNumber: "",
                    phValue: "",
                    ecValue: "",
                    ocValue: "",
                    nValue: "",
                    kValue: "",
                    pValue: "",
                    clayContent: "",
                    cecValue: "",
                }))
            }
        }

        if (name === "selectedFarmerOrVillageType") {
            if (value === "2") {
                const data = soilReports.filter((item) => item.report_level_id === 1)
                const soilVillageData = data.filter((item) => item.ff_group_id === null && item.farmer_id === null && item.year_id === yearIndex)
                const villageGroupData = villageGroups[3].data;
                const villageIds = soilVillageData.map(item => item.village_id.toString());
                // const remainingVillageGroupData = villageGroupData.filter(group => !villageIds.includes(group.village_id));
                const filterVillages = villageGroupData.map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
                setState((prev) => ({
                    ...prev,
                    selectedVillageValue: "",
                    selectedGroupValue: "",
                    selectedFarmerValue: "",
                    selectedSoilTypeId: "",
                    selectedCorpsTypeId: "",
                    surveyNumber: "",
                    phValue: "",
                    ecValue: "",
                    ocValue: "",
                    nValue: "",
                    kValue: "",
                    pValue: "",
                    clayContent: "",
                    cecValue: "",
                    target_year: yearIndex,
                    farmersEnable: true,
                    loading: false,
                    farmersArray: [],
                    villagesArray: filterVillages
                }))
            } else {
                const villageGroupData = villageGroups[3].data;
                const villageData = villageGroupData.map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
                setState((prev) => ({
                    ...prev,
                    selectedVillageValue: "",
                    selectedGroupValue: "",
                    selectedFarmerValue: "",
                    selectedSoilTypeId: "",
                    selectedCorpsTypeId: "",
                    surveyNumber: "",
                    phValue: "",
                    ecValue: "",
                    ocValue: "",
                    nValue: "",
                    kValue: "",
                    pValue: "",
                    clayContent: "",
                    cecValue: "",
                    target_year: yearIndex,
                    farmersEnable: true,
                    loading: false,
                    farmersArray: [],
                    villagesArray: villageData
                }))
            }
            setErrors({});
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [`${name}Error`]: "",
        }));
    };

    useEffect(() => {
        if (villageGroups && villageGroups.length > 0) {
            let villageData = [];
            let groupData = [];
            const villageGroupData = villageGroups[3].data;

            if (user.level_id === 1) {
                villageData = villageGroupData.map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
            } else if (user.level_id === 2) {
                groupData = villageGroupData.map(groupData => ({
                    value: groupData.group_id,
                    label: groupData.Groups
                }))
            }
            setState((prevState) => ({
                ...prevState,
                groupsArray: groupData,
                villagesArray: villageData
            }));

        }
    }, [villageGroups, user.level_id, user.user_level_id]);



    const validateFields = () => {

        const validations = [
            { field: "selectedSoilTypeId", error: "Select Soil Type" },
            { field: "selectedCorpsTypeId", error: "Select Crops Type" },
            { field: "selectedGroupValue", error: "Select Group" },
            { field: "selectedVillageValue", error: "Select Village" },
            ...(state.selectedFarmerOrVillageType !== "2" ? [{ field: "selectedFarmerValue", error: "Select Farmer" }] : []),
            { field: "surveyNumber", error: "Enter Survey Number" },
            { field: "phValue", error: "Enter pH Value" },
            { field: "ecValue", error: "Enter EC Value" },
            { field: "ocValue", error: "Enter OC Value" },
            { field: "nValue", error: "Enter N Value" },
            { field: "pValue", error: "Enter P Value" },
            { field: "kValue", error: "Enter K Value" },
            { field: "clayContent", error: "Enter Clay Content" },
            { field: "cecValue", error: "Enter CEC Value" },
        ];

        const newErrors = validations.reduce((acc, validation) => {

            // Skip validation for selectedVillageValue if level_id is 1
            if (validation.field === "selectedVillageValue" && user?.level_id !== 1) {
                return acc; // Skip error for villages if user level is 1
            }
            // Skip validation for selectedGroupValue if level_id is 2
            if (validation.field === "selectedGroupValue" && user?.level_id !== 2) {
                return acc; // Skip error for groups if user level is 2
            }
            if (!state[validation.field]) {
                acc[`${validation.field}Error`] = validation.error;
            }
            return acc;
        }, {});

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmitSoilReport = async (e) => {
        e.preventDefault();
        if (!validateFields()) {
            return;
        }

        setState((prevState) => ({
            ...prevState,
            loading: true
        }));

        try {
            const existingFarmerSoilDetails = soilReports.filter(
                item => +item.farmer_id === +state.selectedFarmerValue
            );

            let createSoilApi = "";
            if (existingFarmerSoilDetails.length > 0) {
                createSoilApi = await updateSoilReport({
                    id: existingFarmerSoilDetails[0]?.id,
                    soil_type_id: state.selectedSoilTypeId,
                    survey_no: state.surveyNumber,
                    crop_type_id: state.selectedCorpsTypeId,
                    ph: state.phValue,
                    ec: state.ecValue,
                    oc: state.ocValue,
                    n: state.nValue,
                    p: state.pValue,
                    k: state.kValue,
                    clay_content: state.clayContent,
                    recommendations: {},
                    cec: state.cecValue,
                    updated_by: user.user_id
                });
            } else {
                createSoilApi = await createSoilReport({
                    report_level_id: user.level_id,
                    village_id: state.selectedVillageValue === "" ? null : state.selectedVillageValue,
                    ff_group_id: state.selectedGroupValue === "" ? null : state.selectedGroupValue,
                    farmer_id: state.selectedFarmerValue === "" ? null : state.selectedFarmerValue,
                    crop_data: [{
                        soil_type_id: state.selectedSoilTypeId,
                        survey_no: state.surveyNumber,
                        crop_type_id: state.selectedCorpsTypeId,
                        ph: state.phValue,
                        ec: state.ecValue,
                        oc: state.ocValue,
                        n: state.nValue,
                        p: state.pValue,
                        k: state.kValue,
                        clay_content: state.clayContent,
                        cec: state.cecValue,
                        recommendations: []
                    }],
                    target_year: state.target_year,
                    inserted_by: user.user_id
                });
            }

            if (createSoilApi.statusCode === 200) {
                handleSoilReports()
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    submitMessage: createSoilApi.data
                }));
                setSnackbar({
                    open: true,
                    message: createSoilApi.data || "Soil Report Submitted Successfully..",
                    severity: "success",
                });

                setTimeout(() => {
                    navigate('/soilReport/history');
                }, 1000);
            } else {
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    submitMessage: "Submission failed. Please try again."
                }));
            }
        } catch (error) {
            console.error("Error creating soil report:", error);
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    };

    return (
        <>
            <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

            <Box mt={1}>
                <Card elevation={6}>
                    <Grid container spacing={2} p={2}>
                        <FormControl>
                            <RadioGroup
                                row
                                name="selectedFarmerOrVillageType"
                                value={state.selectedFarmerOrVillageType}
                                onChange={(e) => handleInputChange("selectedFarmerOrVillageType", e.target.value)}
                            >
                                {types.map((item) => (
                                    <FormControlLabel
                                        key={item.value}
                                        value={item.value}
                                        control={<Radio color="success" />}
                                        label={item.label}
                                        sx={{ mr: 3 }}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

                    <CardContent>
                        {
                            state.selectedFarmerOrVillageType === "1" ? (
                                <Grid container spacing={1}>
                                    {
                                        [
                                            ...user?.level_id === 1 && state.selectedFarmerOrVillageType === "1" ? [{ id: 1, name: "selectedVillageValue", label: "Select Village", value: state.selectedVillageValue, options: state.villagesArray, error: errors.selectedVillageValueError, type: "select" }] : [],
                                            ...user?.level_id === 2 ? [{ id: 2, name: "selectedGroupValue", label: "Select Group", value: state.selectedGroupValue, options: state.groupsArray, error: errors.selectedGroupValueError, type: "select" }] : [],
                                            { id: 3, name: "selectedFarmerValue", label: "Select Farmer", value: state.selectedFarmerValue, options: state.farmersArray, error: errors.selectedFarmerValueError, disabled: state.farmersEnable, type: "select" },
                                            { id: 4, name: "selectedSoilTypeId", label: "Soil Types", value: state.selectedSoilTypeId, options: soilTypes, error: errors.selectedSoilTypeIdError, type: "select" },
                                            { id: 5, name: "selectedCorpsTypeId", label: "Crops Types", value: state.selectedCorpsTypeId, options: cropTypes, error: errors.selectedCorpsTypeIdError, type: "select" },
                                            { id: 6, name: "surveyNumber", label: "Survey Number", value: state.surveyNumber, error: errors.surveyNumberError, type: "text", limit: 5 },
                                            { id: 7, name: "phValue", label: "PH Value", value: state.phValue, error: errors.phValueError, type: "text", limit: 5 },
                                            { id: 8, name: "ecValue", label: "EC Value", value: state.ecValue, error: errors.ecValueError, type: "text", limit: 5 },
                                            { id: 9, name: "ocValue", label: "OC Value", value: state.ocValue, error: errors.ocValueError, type: "text", limit: 5 },
                                            { id: 10, name: "nValue", label: "N Value", value: state.nValue, error: errors.nValueError, type: "text", limit: 5 },
                                            { id: 11, name: "pValue", label: "P Value", value: state.pValue, error: errors.pValueError, type: "text", limit: 5 },
                                            { id: 12, name: "kValue", label: "K Value", value: state.kValue, error: errors.kValueError, type: "text", limit: 5 },
                                            { id: 13, name: "clayContent", label: "Clay Content", value: state.clayContent, error: errors.clayContentError, type: "text", limit: 5 },
                                            { id: 14, name: "cecValue", label: "CEC", value: state.cecValue, error: errors.cecValueError, type: "text", limit: 5 },
                                            { id: 15, label: "Select Year", name: "target_year", value: years[0]?.value ?? state.target_year, options: [years[0]], disabled: true, type: "select" }
                                        ].map((field, index) => (
                                            <Grid item size={{ xs: 12, md: 4 }} mt={1}>
                                                {
                                                    field.type === "select" ? (
                                                        <SingleSelect
                                                            name={field.name}
                                                            label={field.label}
                                                            options={field.options || []}
                                                            value={field.value}
                                                            disabled={field.disabled}
                                                            onChange={handleInputChange}
                                                            error={field.error}
                                                            formHelperText={true}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            name={field.name}
                                                            type={field.type}
                                                            label={field.label}
                                                            placeholder={field.label}
                                                            value={field.value}
                                                            onChange={(e) => handleInputChange(field.name, e.target.value)}
                                                            inputProps={{ maxLength: field.limit }}
                                                            error={!!field.error}
                                                            helperText={
                                                                field.error ||
                                                                (field.limit
                                                                    ? `${(state[field.name] || "").length}/${field.limit}`
                                                                    : "")
                                                            }
                                                        />
                                                    )
                                                }
                                            </Grid>
                                        )
                                        )
                                    }
                                </Grid>
                            ) : (
                                <SoilVillageCreation villagesArray={state.villagesArray} />
                            )
                        }
                    </CardContent>

                    {state.selectedFarmerOrVillageType === "1" && (
                        <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                            <CustomButton
                                status={state.loading === true ? "loading" : "idle"}
                                onClick={handleSubmitSoilReport}
                                label="Add Report"
                                loadingLabel="Submitting.."
                            />
                        </CardActions>)}
                </Card>
            </Box>


            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </>
    );
}
export default SoilReportCreation;